<ng-select
  [items]="permitTypes()"
  [multiple]="true"
  bindLabel="name"
  bindValue="id"
  [placeholder]="placeholder"
  [formControl]="formControl"
  [closeOnSelect]="false"
  [clearSearchOnAdd]="true"
  (blur)="onBlur()"
  (change)="onSelectionChange($event)"
>
  <ng-template ng-option-tmp let-item="item">
    <input
      type="checkbox"
      [checked]="formControl.value?.includes(item.id)"
    />
    {{ item.name }}
  </ng-template>

  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    @if (allSelected()) {
      <div class="ng-value">
        <span class="ng-value-label">All Permit Types</span>
        <span class="ng-value-icon right" (click)="clearAll()" aria-hidden="true">×</span>
      </div>
    } @else {
      @for (item of items; track item) {
        <div class="ng-value">
          <span class="ng-value-label">{{ item.name }}</span>
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </div>
      }
    }
  </ng-template>
</ng-select>
@if (loadError(); as err) {
  <div class="text-danger small mt-1" role="alert">{{ err }}</div>
}
